// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1eW_k","header":"PatientQuestionnaire_header__QqYPz","info":"PatientQuestionnaire_info__23T6E"};